import Library from './Library'

export default {
  props: {
    name: {
      type: String,
      default: '',
    },

    fontAwesome: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      icon: null,
    }
  },

  computed: {
    isFontAwesomeIcon() {
      return this.fontAwesome.length !== 0
    },

    fontAwesomeIcon() {
      const icon = this.fontAwesome

      return icon
    },
  },

  created() {
    if (this.isFontAwesomeIcon) this.icon = this.fontAwesomeIcon
    else this.icon = Library[this.name]
  },
}
